
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import {
  canPasteElement,
  canPasteElementProperties,
  copyElement,
  getElementToPasteAndPasteElement,
  pasteElementProperties
} from "@/lib/copy-paste/copy-paste";
import { documentStore, uiStore } from "@/store/store";
import { canSaveAsGlobalBlock } from "@/lib/global-blocks/global-blocks";
import { TreeNode } from "@/types/tree";
import GlobalBlockDialog from "@/components/Reusable/GlobalBlockDialog.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { findNode } from "@/lib/tree/tree";
import { getClipboardStatus } from "@/lib/copy-paste/utils";

@Component({
  components: {
    GlobalBlockDialog,
    Dropdown
  }
})
export default class StructureContextMenu extends Vue {
  saveGlobalBlockDialog = false;
  clipboardDialog = false;

  get menuState() {
    return uiStore.onStructurePanelRightClickMenuState !== "closed"
      ? uiStore.onStructurePanelRightClickMenuState
      : null;
  }

  get position() {
    return this.menuState?.position || { x: 0, y: 0 };
  }

  get elementId() {
    return this.menuState?.elementId;
  }

  get element(): TreeNode | undefined {
    return findNode(documentStore.document.tree, this.elementId);
  }

  canPasteElement = false;
  canPasteElementProperties = false;
  permission?: PermissionState;

  @Watch("menuState")
  async onStateChange() {
    const { permission } = await getClipboardStatus();

    this.permission = permission?.state;

    if (this.permission === "prompt") {
      this.canPasteElement = true;
      this.canPasteElementProperties = true;
      return;
    }

    this.canPasteElement = await canPasteElement(
      this.menuState?.elementId
        ? this.menuState.elementId
        : documentStore.document.tree.root.id
    );

    this.canPasteElementProperties = this.menuState?.elementId
      ? await canPasteElementProperties(this.menuState.elementId)
      : false;
  }

  copyElement() {
    if (this.elementId) {
      copyElement(this.elementId);
    }
  }

  pasteElement() {
    if (this.permission === "prompt") {
      this.clipboardDialog = true;
    }

    if (this.elementId) {
      getElementToPasteAndPasteElement(this.elementId);
    } else {
      getElementToPasteAndPasteElement(documentStore.document.tree.root.id);
    }
  }

  pasteElementProperties(path: "design" | "content" | "settings") {
    if (this.permission === "prompt") {
      this.clipboardDialog = true;
    }

    if (this.elementId) {
      pasteElementProperties(this.elementId, path);
    }
  }

  deleteElement() {
    if (!this.elementId) return;

    documentStore.deleteElement({ nodeId: this.elementId });
  }

  openSaveGlobalBlockDialog() {
    if (this.elementId) {
      this.saveGlobalBlockDialog = true;
    }
  }

  closeGlobalBlockDialog() {
    this.saveGlobalBlockDialog = false;
    this.$emit("close");
  }

  get canSaveAsGlobalBlock() {
    return this.elementId && canSaveAsGlobalBlock(this.elementId);
  }

  get shouldShow() {
    return (
      uiStore.onStructurePanelRightClickMenuState !== "closed" &&
      !this.saveGlobalBlockDialog
    );
  }

  set shouldShow(value: boolean) {
    if (!value) {
      uiStore.setOnStructurePanelRightClickMenuState("closed");
    }
  }
}
